var _path, _path2, _path3, _path4, _path5, _path6, _rect, _polygon, _circle, _path7, _path8, _path9, _path10, _rect2, _path11, _path12, _path13, _polygon2, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOb5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 668.6,
    height: 607.38,
    viewBox: "0 0 668.6 607.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m385.32,606.19h-193.12c-28.09,0-50.94-22.85-50.94-50.94V50.94c0-28.09,22.85-50.94,50.94-50.94h193.12c28.09,0,50.94,22.85,50.94,50.94v504.31c0,28.09-22.85,50.94-50.94,50.94Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m385.46,592.4h-193.4c-20.79,0-37.71-16.92-37.71-37.71V50.51c0-20.79,16.92-37.71,37.71-37.71h193.4c20.79,0,37.71,16.92,37.71,37.71v504.18c0,20.79-16.92,37.71-37.71,37.71Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m316.1,46.36h-54.69c-7.22,0-13.09-5.87-13.09-13.09s5.87-13.09,13.09-13.09h54.69c7.22,0,13.09,5.87,13.09,13.09s-5.87,13.09-13.09,13.09Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m301.5,279.12v35.95h-103.83c-9.91,0-17.98-8.06-17.98-17.98s8.07-17.97,17.98-17.97h103.83Z",
    fill: "#86cdf5",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m379.85,279.12h-182.18c-9.91,0-17.98,8.06-17.98,17.97s8.07,17.98,17.98,17.98h182.18c9.92,0,17.98-8.06,17.98-17.98s-8.06-17.97-17.98-17.97Zm0,29.95h-182.18c-6.6,0-11.98-5.37-11.98-11.98s5.38-11.97,11.98-11.97h182.18c6.61,0,11.98,5.37,11.98,11.97s-5.37,11.98-11.98,11.98Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m668.6,606.19c0,.66-.53,1.19-1.19,1.19H1.19c-.66,0-1.19-.53-1.19-1.19s.53-1.19,1.19-1.19h666.22c.66,0,1.19.53,1.19,1.19Z",
    fill: "#2e2e43",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 514.09,
    y: 542.41,
    width: 20.36,
    height: 28.88,
    transform: "translate(-217.38 370.06) rotate(-32.59)",
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "470.67 212.1 449 219.5 448.66 188.21 468.38 187.99 470.67 212.1",
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 451.19,
    cy: 175.18,
    r: 21.67,
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m457.12,172.97c-3.62-.07-6.05-3.7-7.5-7.04-1.45-3.32-2.94-7.16-6.31-8.51-2.76-1.1-7.52,6.58-9.72,4.58-2.29-2.09-.2-13.01,2.19-14.98s5.67-2.39,8.75-2.58c7.55-.43,15.14.09,22.56,1.56,4.58.9,9.32,2.29,12.65,5.56,4.23,4.15,5.37,10.47,5.73,16.38.38,6.05.09,12.39-2.79,17.73-2.89,5.33-9,9.3-14.93,8.02-.63-3.21-.07-6.5.13-9.78.2-3.26-.09-6.78-2.11-9.36s-6.28-3.56-8.57-1.23",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m483.86,180.18c2.15-1.61,4.72-2.97,7.39-2.67,2.89.31,5.35,2.67,6.12,5.47s-.03,5.9-1.78,8.22-4.38,3.86-7.18,4.65c-1.62.46-3.39.65-4.95,0-2.29-.96-3.55-3.85-2.68-6.18",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-33948de9-fd1c-48f0-90c0-61f62e58bd4f-48-752",
    d: "m403.22,384.9c-1.36,7.13,1.35,13.61,6.07,14.46,4.71.85,9.64-4.25,11.01-11.38.59-2.84.46-5.78-.38-8.57l16.67-111.76-22.46-3.96-7.39,113.36c-1.81,2.32-3.02,5.01-3.52,7.88h0v-.03h0Z",
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m448.6,205.14l-15.3.17c-10.8,1.75-13.67,7.56-16,18.24-3.57,16.29-8.13,38-7.17,38.3,1.53.5,27.7,12.46,40.95,9.5l-2.47-66.21h-.01Z",
    fill: "#86cdf5",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 447.19,
    y: 560.47,
    width: 20.36,
    height: 28.88,
    transform: "translate(-6.39 5.14) rotate(-.64)",
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m427.67,607.17c-2.15.03-4.04,0-5.48-.12-5.42-.43-10.61-4.37-13.24-6.67-1.18-1.03-1.57-2.71-.98-4.15h0c.42-1.03,1.28-1.82,2.36-2.15l14.25-4.24,22.97-15.87.26.46c.1.17,2.42,4.24,3.21,7,.3,1.05.24,1.92-.2,2.6-.3.47-.72.75-1.06.92.42.43,1.74,1.31,5.8,1.91,5.9.88,7.09-5.26,7.13-5.52l.04-.21.17-.12c2.79-1.85,4.5-2.68,5.1-2.51.38.1.99.29,2.85,16.93.17.52,1.39,4.34.63,8.02-.82,4-18.27,2.81-21.75,2.54-.1.01-13.14,1.09-22.08,1.18h.03-.01Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m502.84,602.37c-2.39.03-4.59-.24-6.16-.5-1.54-.26-2.76-1.47-3.02-3.01h0c-.2-1.11.13-2.22.86-3.06l9.84-11.14,11.08-25.62.47.25c.17.09,4.29,2.32,6.43,4.24.81.73,1.22,1.5,1.22,2.32,0,.56-.21,1.02-.42,1.33.59.14,2.17.18,5.93-1.45,5.47-2.38,3.23-8.22,3.13-8.45l-.08-.2.09-.18c1.39-3.04,2.41-4.66,3-4.84.38-.1.99-.29,11.38,12.85.42.35,3.48,2.94,4.78,6.46,1.41,3.83-14,12.05-17.12,13.66-.09.08-16.2,12.05-22.82,15.48-2.63,1.36-5.76,1.81-8.61,1.83l.03.03h-.01Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m479.66,318.62l-57,.63-4.58,53.08,24.81,195.68,29.1-.33-12.89-113.03,48.34,101.65,25.66-18.4-37.92-94.98s12.25-83.24,1.67-103.82c-10.57-20.58-17.18-20.51-17.18-20.51v.03h-.01Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "508.04 321.54 417.51 322.55 443.37 205.21 482.82 204.76 508.04 321.54",
    fill: "#86cdf5",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-03c337cc-94cb-40f4-b3c5-a174ed3003cd-49-753",
    d: "m516.88,383.64c1.52,7.11-1.05,13.64-5.74,14.59-4.7.96-9.74-4.03-11.25-11.14-.65-2.83-.59-5.77.18-8.58l-19.16-111.37,22.36-4.46,9.91,113.18c1.86,2.28,3.13,4.95,3.7,7.8h0v-.02Z",
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m467.53,204.93l15.3-.17c10.83,1.52,13.83,7.26,16.41,17.89,3.93,16.21,8.96,37.8,8.02,38.13-1.53.52-27.41,13.06-40.72,10.4l1.01-66.25h-.02Z",
    fill: "#86cdf5",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOb5);
export default __webpack_public_path__ + "static/media/ob5.41f62be063290efc85617912a9c8d621.svg";
export { ForwardRef as ReactComponent };